export enum SidebarType {
    SMS_CONVERSATION = 'smsConversation',
    INTER_ACCOUNT_LEADS = 'interAccountLeads',
    ADD_LEAD = 'addLead',
}
